import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehousesSearchResponse as SchemaDeliveryWarehousesSearchResponse } from '../schemas/DeliveryWarehousesSearchResponse';
import { type DeliveryWarehouseStatus as SchemaDeliveryWarehouseStatus } from '../schemas/DeliveryWarehouseStatus';
import { type WarehouseType as SchemaWarehouseType } from '../schemas/WarehouseType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const SearchDeliveryWarehousesContentType = '' as const;
export type SearchDeliveryWarehousesRequest = void;
export type SearchDeliveryWarehousesResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaDeliveryWarehousesSearchResponse;
    };
};
export type SearchDeliveryWarehousesResponseSuccess = SearchDeliveryWarehousesResponses['200']['application/json'];
export type SearchDeliveryWarehousesSearchParams = {
    page?: number;
    per_page?: number;
    query?: string;
    delivery_statuses?: SchemaDeliveryWarehouseStatus[];
    type?: SchemaWarehouseType;
};
export type SearchDeliveryWarehousesPathParameters = undefined;
export const SearchDeliveryWarehousesUrl = '/delivery/warehouses/search' as const;
export const SearchDeliveryWarehousesMethod = 'GET' as const;
export const getSearchDeliveryWarehousesUrl = (_params?: SearchDeliveryWarehousesPathParameters) =>
    SearchDeliveryWarehousesUrl;
